import React from 'react'
import Header from '../header'
import Footer from '../footer'
import FooterMenu from '../../molecules/footermenu'
import FirstView from '../../molecules/firstview'
import Topscroll from '../../molecules/topscroll'
import Prof from '../../sidebar/prof'
import Search from '../../sidebar/search'
import * as styles from './layout.module.css'

const Layout = ({ location, title, children }) => {

  let h1 = false
  let firstView
  if (location.pathname === `${__PATH_PREFIX__}/` || location.pathname.match(/page/)) h1 = true
  if (location.pathname === `${__PATH_PREFIX__}/`) firstView = <div className={styles.firstview}><div className='paper'><FirstView /></div></div>

  return (
    <>
      <Header title={title} h1={h1} />
      <div className={styles.container}>
        {firstView}
        <div className={styles.contents}>
          <div className={styles.main}>
            {/* メインコンテンツ */}
            <div className={styles.main_content}>
              <div className='paper'>
                <main>{children}</main>
              </div>
            </div>
          </div>
          <div className={styles.sidebar}>
            <div className='paper'>
              <Prof />
              <Search />
            </div>
          </div>
        </div>
      </div>
      <Footer title={title} />
      <FooterMenu />
      <Topscroll />
    </>
  )
}

export default Layout